import { render, staticRenderFns } from "./IntellectualPropertyFrom.vue?vue&type=template&id=5a8fc9d5&scoped=true&"
import script from "./IntellectualPropertyFrom.vue?vue&type=script&lang=js&"
export * from "./IntellectualPropertyFrom.vue?vue&type=script&lang=js&"
import style0 from "./IntellectualPropertyFrom.vue?vue&type=style&index=0&id=5a8fc9d5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a8fc9d5",
  null
  
)

export default component.exports